(function () {
    const translations = {
        en: {
            standardDiscount: 'Standard discount'
        },
        nl: {
            standardDiscount: 'Standaard korting'
        },
        de: {
            standardDiscount: 'Standardrabatt'
        },
        fr: {
            standardDiscount: 'Remise standard'
        }
    };

    function getCurrentLanguage() {
        let lang = (typeof Shopify !== 'undefined' && Shopify.locale) ? Shopify.locale : null;
        
        if (!lang) {
            const urlParams = new URLSearchParams(window.location.search);
            lang = urlParams.get('locale') || 'en';
        }
        
        if (!translations[lang]) {
            lang = 'en';
        }
        
        return lang;
    }

    function translateDiscountLabels() {
        const lang = getCurrentLanguage();
        const t = translations[lang];

        const discountElements = document.querySelectorAll('div.discount.text-sm');
        
        discountElements.forEach((item) => {
            const originalText = item.textContent.trim();
            
            if (originalText.match(/standard discount/i)) {
                item.textContent = t.standardDiscount;
            }
        });
    }

    const observer = new MutationObserver((mutations, obs) => {
        const discountExists = document.querySelector('div.discount.text-sm');
        
        if (discountExists) {
            translateDiscountLabels();
            obs.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    setTimeout(() => {
        translateDiscountLabels();
    }, 2000);
    
    setTimeout(() => {
        translateDiscountLabels();
        observer.disconnect();
    }, 5000);
})();
